import { styled } from '@mui/material/styles';
import { JE_TABLE_CLASSES } from '@/components/Tables/grid/StyledComponents';
import c from '@/components/Tables/constatnt';

export const JETableOverride = styled('div', {
  label: 'JETableOverride',
})(({ theme }) => ({
  position: 'relative',

  [`& .${JE_TABLE_CLASSES.TABLE}`]: {
    position: 'relative',
  },

  [`& .${JE_TABLE_CLASSES.COLGROUP_COL}`]: {
    width: '20%',
  },

  [`& .${JE_TABLE_CLASSES.ROW}`]: {
    '&:nth-child(2n)': {
      height: c.ROW_HEIGHT + c.BLOCK_GAP,
      '& td': {
        paddingBottom: c.BLOCK_GAP,
      },
    },
  },

  [`& .${JE_TABLE_CLASSES.CELL}`]: {
    paddingLeft: 11,
    paddingRight: 11,
    paddingBottom: 0,
    paddingTop: 0,

    '& [data-element="je.fakeCell.value"]': {
      borderBottom: '1px solid #DEE2E6',
      paddingLeft: 0,
    },
    '& [data-element="je.description"], & [data-element="je.readonly"]': {
      padding: 0,
    },
  },

  [`& .${JE_TABLE_CLASSES.CELL_MANDATORY}`]: {
    '& [data-element="je.fakeCell.value"]': {
      borderBottomColor: theme.palette.error.main,
    },
  },

  [`& .${JE_TABLE_CLASSES.CELL_ACTIVE}`]: {
    zIndex: 16,

    '& [data-element="je.fakeCell.value"], & [data-element="je.autocomplete.field"]': {
      borderBottom: `2px solid ${theme.palette.primary.light}`,
    },
    '& [data-element="je.hintinput.field"], & [data-element="je.literal.field"] ': {
      borderBottom: `2px solid ${theme.palette.primary.light}`,
      padding: 0,
    },
  },
}));
